export default __webpack_public_path__ + "static/media/events.1128884f.svg";